<template>
  <aside id="iq-sidenav">
    <a href="#" data-target="slide-out" class="sidenav-trigger">&#127814;</a>
    <ul id="slide-out" class="sidenav sidenav-fixed">
      <li>
        <div class="user-view">
          <div class="background">
            <img src="https://g.foolcdn.com/misc-assets/bg-tablet.jpg">
          </div>
          <img class="circle avatar" :src="$auth.isAuthenticated ? $auth.user.avatar : 'https://g.foolcdn.com/misc-assets/prof-colleague.jpg'">
          <span class="blue-grey-text text-darken-4 name">
            {{ $auth.isAuthenticated ? $auth.user.name : 'Jane Doe' }}
          </span>
          <span class="blue-grey-text text-darken-4 email">
            {{ $auth.isAuthenticated ? $auth.user.email : 'iq@fool.com' }}
          </span>
        </div>
      </li>
      <li>
        <a class="subheader"><span class="blue-grey-text text-lighten-3 italics">Main</span></a>
      </li>
      <li>
        <router-link to="/" class="waves-effect sidenav-close blue-grey-text text-darken-2">
          Home
        </router-link>
      </li>
      <li>
        <router-link to="/company?company_id=1624" class="waves-effect sidenav-close blue-grey-text text-darken-2">
          Company
        </router-link>
      </li>
      <li>
        <div class="divider" />
      </li>
      <li>
        <a class="subheader"><span class="blue-grey-text text-lighten-3 italics">Admin</span></a>
      </li>
      <li>
        <router-link to="/bbn" class="waves-effect sidenav-close blue-grey-text text-darken-2">
          Best Buys Now
        </router-link>
      </li>
      <li>
        <router-link to="/tickeradmin/listcompanies" class="waves-effect sidenav-close blue-grey-text text-darken-2">
          Ticker Admin
        </router-link>
      </li>
      <li>
        <router-link to="/cryptoadmin/listcryptos" class="waves-effect sidenav-close blue-grey-text text-darken-2">
          Crypto Admin
        </router-link>
      </li>
      <li>
        <router-link to="/useradmin/listusers" class="waves-effect sidenav-close blue-grey-text text-darken-2">
          Users
        </router-link>
      </li>
      <li>
        <div class="divider" />
      </li>
      <li>
        <a class="waves-effect sidenav-close blue-grey-text text-darken-2"
           @click.prevent="routeLogout"
        >
          {{ $auth.isAuthenticated ? 'Logout' : 'Login' }}
        </a>
      </li>
    </ul>
  </aside>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'SideNav',
  methods: {
    ...mapMutations(['logout']),
    initSideNav() {
      return this.materialize.Sidenav.init(document.getElementById('slide-out'), {
        edge: 'left',
        draggable: true,
        preventScrolling: true,
      })[0];
    },
    initSideBar() {
      const sideBar = document.querySelector('div.drag-target');
      sideBar.onmouseenter = evt => {
        document.querySelector('a.sidenav-trigger').click();
      };
      return sideBar;
    },
    routeLogout() {
      if (this.$auth.isAuthenticated) {
        this.$auth.logout({
          returnTo: window.location.origin,
        });
      } else {
        this.$router.push('/login');
      }
    },
  },
  mounted() {
    this.initSideNav();
    this.initSideBar();
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

#iq-sidenav {
  a {
    height: 40px;
    &.router-link-exact-active {
      background-color: $tmf-gains;
    }
  }
}

.circle.avatar {
  margin: auto;
}

.sidenav .user-view {
  margin-bottom: 0px;
  padding: 20px 0px 0px 0px;
}

.sidenav {
  width: 220px;
}
</style>
